// PersonalCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import DignifiedPersonalCareSection from '../components/DignifiedPersonalCareSection';
import PersonalCareServicesSection from '../components/PersonalCareServicesSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import MealPreparationSection from '../components/MealPreparationSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const PersonalCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: null },
    { label: 'Personal Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Personal Care From The Comfort Of Home"
        description="We provide you or your family member with much-needed assistance all from the comfort of home."
      />
      <DignifiedPersonalCareSection />
      <PersonalCareServicesSection />
      <ProudlyCaringSeniorsSection />
      <MealPreparationSection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default PersonalCare;
